import "./index.scss";
import * as _ from "lodash";
import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Tabs from "../../../components/core/tab";
import { readProfileAppearanceByProfileId } from "../../../store/profile-appearance/thunkAction";
import { useTranslation } from "react-i18next";

const ProfileAppearance = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const profileId = _.get(params, "id");

  useEffect(() => {
    dispatch(readProfileAppearanceByProfileId(profileId));
  }, [profileId, dispatch]);

  const configTabs = {
    isPath: true,
    tabs: [
      {
        label: t("settings.profile.window"),
        path: `/profile/${profileId}/appearances/window`,
      },
      {
        label: t("settings.profile.chat_badge"),
        path: `/profile/${profileId}/appearances/chat-badge`,
      },
      {
        label: t("settings.profile.content"),
        path: `/profile/${profileId}/appearances/content`,
      },
    ],
  };

  return (
    <div className="container">
      <div>
        <div className="row header-title mb-4">
          <div className="col-lg-6">
            <h3 className="color-pri">
              {t("settings.profile.profile_appearance.title")}
            </h3>
          </div>
          <div className="col-lg-6 text-start text-lg-end align-self-center">
            <a className="default-link" href={`#/profile/${profileId}/detail`}>
              <i className="fa fa-arrow-left"></i>{" "}
              {t("settings.profile.profile_detail")}
            </a>
          </div>
        </div>
        <Tabs config={configTabs} />
        <br />
        <div style={{ marginTop: "5px" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProfileAppearance;
